export const TYPES = {
    Markets: 'markets',
    Order: 'order',
    CompetingProducts: 'competingProducts',
    Other: 'other',
}
export const TYPE_FIELD = 'type'
export const RECORD_FIELD = 'record'
